import type { TMessages } from '@/types/TMessages'

export const messages = { button: 'Получить консультацию' } satisfies TMessages
